<template>
	<div class="models">
		<div class="mcontentwrap px-6 py-4">
			<div class="tabssec">
				<div class="is-flex is-justify-content-space-between is-align-items-center mx-0 mt-3 mb-5">
					<div class="is-size-4 poppins-medium is-capitalized">{{ $route.params.page }}</div>
					<div class="pagination mb-0" v-if="models.length">
						<vue-awesome-paginate
							:total-items="models.length"
							:items-per-page="perPage"
							:max-pages-shown="5"
							v-model="currentPage"
							:hide-prev-next="true"
						>
						</vue-awesome-paginate>
					</div>
				</div>
				<div class="content mt-5" v-if="models.length && $route.params.page !== 'tools'">
					<div class="content poppins-medium">
						To install <strong class="green">Blocks</strong> and <strong class="green">Textures</strong>, drag the files from the .zip
						(not the zip itself) into their respective folders:
						<ul class="mt-1">
							<li>Documents/TrackMania/Blocks/<em>**your Blocks folder**</em></li>
							<li>Documents/TrackMania/Blocks/Data/<em>**your Textures folder**</em></li>
						</ul>
					</div>
				</div>
				<div v-if="!models.length">
					<section class="hero">
						<div class="hero-body">
							<p class="title">Coming soon<sup>TM</sup></p>
						</div>
					</section>
				</div>
				<div class="columns is-multiline">
					<AddCard v-if="auth.state.isLoggedIn && currentPage === 1" @click="openAdd"></AddCard>
					<SetCard v-for="(i, j) in modelsPaginated" :key="i.id || j" :item="i" @edit="openEdit" @delete="onDelete"></SetCard>
				</div>
			</div>
		</div>
		<AddItemModal
			:show="showAddModal"
			:editing-item="editingItem"
			:item-label="$route.params.page === 'tools' ? 'Tool' : 'Block'"
			:on-submit="handleSubmit"
			@close="onModalClose"
		></AddItemModal>
	</div>
</template>

<script>
import SetCard from '@/components/SetCard.vue';
import AddCard from '@/components/AddCard.vue';
import AddItemModal from '@/components/AddItemModal.vue';
import db from '@/db.js';
import auth from '@/auth.js';
import customItems from '@/customItems.js';

export default {
	components: { SetCard, AddCard, AddItemModal },
	data() {
		return {
			auth,
			currentPage: 1,
			perPage: 8,
			showAddModal: false,
			editingItem: null,
		};
	},
	computed: {
		models() {
			const page = this.$route.params.page;
			return [...customItems.getItems(page).slice().reverse(), ...(db[page] || [])];
		},
		modelsPaginated() {
			return this.models.slice((this.currentPage - 1) * this.perPage, this.currentPage * this.perPage);
		},
	},
	watch: {
		$route() {
			this.currentPage = 1;
		},
	},
	methods: {
		openAdd() {
			this.editingItem = null;
			this.showAddModal = true;
		},
		openEdit(item) {
			this.editingItem = item;
			this.showAddModal = true;
		},
		onModalClose() {
			this.showAddModal = false;
			this.editingItem = null;
		},
		async handleSubmit({ isEdit, id, payload }) {
			if (isEdit) {
				return customItems.updateItem(this.$route.params.page, id, payload);
			}
			return customItems.addItem(this.$route.params.page, payload);
		},
		async onDelete(item) {
			if (!confirm(`Delete "${item.title}"?`)) return;
			const result = await customItems.deleteItem(this.$route.params.page, item.id);
			if (!result.ok) {
				alert(result.error || 'Could not delete this item.');
			}
		},
	},
};
</script>

<style scoped>
.button {
	font-weight: 700;
	background-color: #70cb7c;
	color: #131417;
	box-shadow: 0 2px 10px 0px #00000040;
	border-radius: 3px;
	border-color: #70cb7c;
}
.button:hover {
	background-color: #89ce92;
}
.green {
	color: #89ce92;
}
.content {
	padding: 0.75rem;
	border-radius: 20px;
	background-color: #1e1f25;
}
</style>
